import { render, staticRenderFns } from "./ObjectiveHeading.vue?vue&type=template&id=07f57bb0&scoped=true"
import script from "./ObjectiveHeading.vue?vue&type=script&lang=js"
export * from "./ObjectiveHeading.vue?vue&type=script&lang=js"
import style0 from "./ObjectiveHeading.vue?vue&type=style&index=0&id=07f57bb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f57bb0",
  null
  
)

export default component.exports